/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { OutbOrd04Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const outbOrd04ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const outbOrd04FetchOutbOrd04Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const outbOrd04FetchOutbOrd04Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const outbOrd04AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const outbOrd04RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const outbOrd04SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const outbOrd04CreateOutbOrd04Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const outbOrd04CreateOutbOrd04Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

export const outbOrd04SetExpandedRows = (state, { expandedRows }) => ({
  ...state,
  expandedRows
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [OutbOrd04Types.OUTB_ORD04_RESET_TIMESTAMP]: outbOrd04ResetTimestamp,
  [OutbOrd04Types.OUTB_ORD04_FETCH_OUTB_ORD04_LOADING]: outbOrd04FetchOutbOrd04Loading,
  [OutbOrd04Types.OUTB_ORD04_FETCH_OUTB_ORD04_SUCCESS]: outbOrd04FetchOutbOrd04Success,
  [OutbOrd04Types.OUTB_ORD04_ADD_SELECTED_DOCUMENTS]: outbOrd04AddSelectedDocuments,
  [OutbOrd04Types.OUTB_ORD04_REMOVE_SELECTED_DOCUMENTS]: outbOrd04RemoveSelectedDocuments,
  [OutbOrd04Types.OUTB_ORD04_SET_WORKSPACE_VISIBLE]: outbOrd04SetWorkspaceVisible,
  [OutbOrd04Types.OUTB_ORD04_CREATE_OUTB_ORD04_LOADING]: outbOrd04CreateOutbOrd04Loading,
  [OutbOrd04Types.OUTB_ORD04_CREATE_OUTB_ORD04_SUCCESS]: outbOrd04CreateOutbOrd04Success,
  [OutbOrd04Types.OUTB_ORD04_SET_EXPANDED_ROWS]: outbOrd04SetExpandedRows
});
